import { useSubscriptionsStore } from "@shared/stores/subscriptions";
import { useAuthStore } from "@shared/stores/auth";
import { rolesService } from "@shared/services/roles";
import { useVersionStore } from "@shared/stores/version";
import { type AppcuesEvents } from "@shared/types/global";
import { useEngine } from "@shared/use/useEngine.ts";
import { appcuesClientImpl } from "@shared/module-transformers/appcuesClientImpl.ts";
import { useGenVersionStore } from "@shared/stores/genVersion.ts";

export const appcuesService = {
  setSubscriptionProperties(): void {
    if (!appcuesClientIsAvailable()) {
      return;
    }
    const authStore = useAuthStore();
    if (!authStore.user) {
      return;
    }
    const subscriptionStore = useSubscriptionsStore();
    const versionStore = useVersionStore();
    const genVersionStore = useGenVersionStore();
    const role = rolesService.extractUserRoleForSubscription(
      subscriptionStore.currentSubscriptionNumber,
    );

    appcuesClientImpl.identify(authStore.user.heapIdentity, {
      myjfrog_isInternalJfrogUser: authStore.user.email.includes("@jfrog.com"),
      myjfrog_subscriptionId:
        subscriptionStore.currentSubscription?.accountNumber,
      myjfrog_subscriptionType:
        subscriptionStore.currentSubscription?.paymentType,
      myjfrog_isTrialSubscription: subscriptionStore.currentSubscription?.trial,
      myjfrog_hasBusinessSecurity:
        subscriptionStore.currentSubscription?.hasBusinessSecurity,
      myjfrog_paymentType:
        subscriptionStore.currentSubscription?.meta.paymentTypeName,
      myjfrog_isSaas: subscriptionStore.currentSubscription?.meta.isSaas,
      myjfrog_isSelfHosted:
        subscriptionStore.currentSubscription?.meta.isSelfHosted,
      myjfrog_role: role,
      myjfrog_ng: genVersionStore.isNewGen,
      myjfrog_engine: useEngine().engine,
      myjfrog_version: versionStore.version,
    });
  },
  setUserIdentityProperties(): void {
    if (!appcuesClientIsAvailable()) {
      return;
    }
    const authStore = useAuthStore();
    if (!authStore.user) {
      return;
    }

    appcuesClientImpl.identify(authStore.user.heapIdentity, {
      myjfrog_isInternalJfrogUser: authStore.user.email.includes("@jfrog.com"),
      myjfrog_engine: useEngine().engine,
    });
  },

  sendEvent(eventName: AppcuesEvents, payload?: Record<string, unknown>): void {
    if (!appcuesClientIsAvailable()) {
      return;
    }
    payload = payload || {};
    payload["myjfrog_engine"] = useEngine().engine;
    appcuesClientImpl.track(eventName, payload);
  },
};

const appcuesClientIsAvailable = () => {
  return (
    !!appcuesClientImpl &&
    !!appcuesClientImpl.identify &&
    !!appcuesClientImpl.track
  );
};
